import { EnhancedEvent } from "../events/types";

type OverrideTimestamp = (event: EnhancedEvent) => { timestamp: Date };

/**
 * Composes an options object to be consumed by PostHog's capture method to override the event timestamp.
 *
 * @param event - Event
 * @returns Options object with overwritten timestamp
 */
const overrideTimestamp: OverrideTimestamp = (event) => {
  return {
    timestamp: new Date(event.timestamp),
  };
};

export { overrideTimestamp };
